<div class="bg-white h-full flex flex-col">
    <!-- Header -->
    <div class="px-6 py-4 border-b border-gray-100">
        <div class="flex items-center justify-between">
            <div>
                <h2 class="text-lg font-semibold text-gray-900">{{ 'BUY_CREDITS' | translate }}</h2>
                <p class="text-sm text-gray-500 mt-0.5">{{ 'SELECT_CREDITS_PACK' | translate }}</p>
            </div>
            <button (click)="close()"
                    class="p-2 hover:bg-gray-100 rounded-lg transition-colors">
                <i class="fa-solid fa-xmark text-gray-500"></i>
            </button>
        </div>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-y-auto px-6 py-5">
        <!-- Info Banner -->
        <div class="mb-5 p-3 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-100">
            <div class="flex items-center gap-3">
                <div class="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                    <i class="fa-solid fa-info text-blue-600 text-sm"></i>
                </div>
                <div class="flex-1">
                    <p class="text-sm text-blue-700">{{ 'CREDITS_INFO_DESCRIPTION' | translate }}</p>
                </div>
            </div>
        </div>

        <!-- Action Section (moved before packs) -->
        <div *ngIf="!loading && !error" class="mb-5 p-4 bg-gray-50 rounded-xl border border-gray-200">
            <div class="flex items-center justify-between gap-4">
                <!-- Selected Pack Summary -->
                <div class="flex items-center gap-3 flex-1 min-w-0">
                    <div class="w-10 h-10 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                        <i class="fa-solid fa-coins text-white text-sm"></i>
                    </div>
                    <div *ngIf="selectedPack" class="min-w-0">
                        <div class="text-sm font-semibold text-gray-900">{{selectedPack.quantity}} {{ 'CREDITS' | translate }}</div>
                        <div class="text-lg font-bold text-primary">${{selectedPack.price}}
                            <span *ngIf="getDiscount(selectedPack)" class="text-xs text-green-600 font-medium ml-1">-{{getDiscount(selectedPack)}}%</span>
                        </div>
                        <div class="text-xs text-gray-500 mt-0.5">{{ 'PRICE_EXCLUDES_VAT' | translate }}</div>
                    </div>
                    <div *ngIf="!selectedPack" class="text-sm text-gray-500">{{ 'SELECT_A_PACK_BELOW' | translate }}</div>
                </div>

                <!-- Continue Button -->
                <button (click)="purchaseCredits()"
                        type="button"
                        [disabled]="!selectedPack || purchasing"
                        class="h-11 px-6 rounded-lg bg-primary text-white text-sm font-medium transition-all hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 flex-shrink-0">
                    <ion-spinner *ngIf="purchasing" name="crescent" class="w-4 h-4"></ion-spinner>
                    <i *ngIf="!purchasing" class="fa-solid fa-credit-card"></i>
                    <span>{{ purchasing ? ('PROCESSING' | translate) : ('CONTINUE_TO_PAYMENT' | translate) }}</span>
                </button>
            </div>
            <!-- Secure Payment Note -->
            <div class="mt-2 flex items-center gap-1.5 text-xs text-gray-400">
                <i class="fa-solid fa-lock text-[10px]"></i>
                <span>{{ 'SECURE_PAYMENT_BY_STRIPE' | translate }}</span>
            </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="loading" class="flex flex-col items-center justify-center py-12">
            <ion-spinner name="crescent" class="text-primary"></ion-spinner>
            <p class="mt-3 text-sm text-gray-500">{{ 'LOADING_CREDITS_PACKS' | translate }}</p>
        </div>

        <!-- Error State -->
        <div *ngIf="error && !loading" class="p-4 bg-red-50 border border-red-200 rounded-xl">
            <div class="flex items-center gap-2 text-red-700">
                <i class="fa-solid fa-circle-exclamation"></i>
                <span class="text-sm">{{error}}</span>
            </div>
            <button (click)="loadCreditsPacks()"
                    class="mt-3 text-sm text-red-600 hover:text-red-800 font-medium">
                {{ 'TRY_AGAIN' | translate }}
            </button>
        </div>

        <!-- Credits Packs Grid -->
        <div *ngIf="!loading && !error" class="grid grid-cols-4 gap-3">
            <div *ngFor="let pack of creditsPacks"
                 (click)="selectPack(pack)"
                 class="relative p-3 rounded-lg border-2 cursor-pointer transition-all duration-200 hover:shadow-md"
                 [ngClass]="{
                    'border-primary bg-primary/5 shadow-md': selectedPack?._id === pack._id,
                    'border-gray-200 bg-white hover:border-gray-300': selectedPack?._id !== pack._id
                 }">

                <!-- Discount Badge -->
                <div *ngIf="getDiscount(pack)"
                     class="absolute -top-1.5 -right-1.5 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full shadow-sm">
                    -{{getDiscount(pack)}}%
                </div>

                <!-- Selected Indicator -->
                <div *ngIf="selectedPack?._id === pack._id"
                     class="absolute top-2 right-2 w-5 h-5 bg-primary rounded-full flex items-center justify-center">
                    <i class="fa-solid fa-check text-white text-[10px]"></i>
                </div>

                <!-- Pack Content -->
                <div class="text-center">
                    <!-- Credits Icon -->
                    <div class="w-10 h-10 mx-auto mb-2 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center shadow">
                        <i class="fa-solid fa-coins text-white text-sm"></i>
                    </div>

                    <!-- Credits Amount -->
                    <div class="text-xl font-bold text-gray-900">{{pack.quantity}}</div>
                    <div class="text-xs text-gray-500 font-medium">{{ 'CREDITS' | translate }}</div>

                    <!-- Price -->
                    <div class="mt-2 pt-2 border-t border-gray-100">
                        <div class="text-base font-bold text-gray-900"><span class="text-sm">$</span>{{pack.price}}</div>
                        <div class="text-[10px] text-gray-400">${{getPricePerCredit(pack)}}/{{ 'CREDIT' | translate }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Best Value Tip -->
        <div *ngIf="creditsPacks.length >= 3 && !loading" class="mt-3 text-center">
            <span class="inline-flex items-center gap-1.5 text-xs text-gray-500">
                <i class="fa-solid fa-star text-amber-400"></i>
                {{ 'BEST_VALUE_TIP' | translate }}
            </span>
        </div>
    </div>

    <!-- Footer -->
    <div class="px-6 py-3 border-t border-gray-100 bg-gray-50">
        <div class="flex justify-end">
            <button (click)="close()"
                    type="button"
                    class="h-9 px-5 rounded-lg bg-white text-gray-600 text-sm font-medium transition-colors border border-gray-300 hover:bg-gray-50">
                {{ 'CANCEL' | translate }}
            </button>
        </div>
    </div>
</div>
